import { AccountRequestStatus } from '@app/constants/requests';
import { useTranslation } from 'react-i18next';

export const useAccountRequestStatusLabel = () => {
  const { t } = useTranslation(['accounts']);

  const getStatusLabel = (status: AccountRequestStatus) => {
    switch (status) {
      case AccountRequestStatus.Archived:
        return t('accounts:archived');
      case AccountRequestStatus.Declined:
        return t('accounts:declined');
      case AccountRequestStatus.Pending:
        return t('accounts:pending');
      case AccountRequestStatus.Accepted:
        return t('accounts:approved');
      default:
        return '';
    }
  };

  return {
    getStatusLabel,
  };
};
